import DocumentsController from './documents.controller';

export default {
    template: require('./documents.tpl.html'),
    controller: DocumentsController
};
